import ClearIcon from '@mui/icons-material/Clear';
import { connectSearchBox } from 'react-instantsearch-dom';

import { TSearchBoxProps } from '../types';
import { SIconButton, SSearch, STextField } from '../style';

export const SearchBox = connectSearchBox(
  ({ className, placeholder, currentRefinement, isSearchStalled, refine }: TSearchBoxProps): JSX.Element => {
    return (
      <SSearch>
        <STextField
          fullWidth
          value={currentRefinement}
          onChange={(event) => refine(event.currentTarget.value)}
          className={className}
          placeholder={placeholder}
        />
        {(!!currentRefinement.length || isSearchStalled) && (
          <SIconButton onClick={() => refine('')}>
            <ClearIcon />
          </SIconButton>
        )}
      </SSearch>
    );
  }
);
